'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "empty", "error", "isValidating", "onSuccess", "pristine", "trimInputValue", "validateDefaultValue", "validateInput", "validationMessage", "validationOpts", "validator"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import UIValidator from '../UIValidator';
import { propTypes } from './UIValidatedFormControlPropsInterface';
import messageDefaults from '../constants/messageDefaults';
import WrappedChildInput from '../utils/components/WrappedChildInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
class UIValidatedFormControl extends Component {
  constructor(...args) {
    super(...args);
    this.getMessage = () => {
      const {
        validationMessage,
        error,
        empty,
        isValidating,
        pristine
      } = this.props;
      if (pristine) {
        return '';
      }
      if (isValidating) {
        return validationMessage.validating;
      }
      if (empty) {
        return validationMessage.empty;
      }
      if (error) {
        return validationMessage.error;
      }
      return validationMessage.success;
    };
  }
  componentDidMount() {
    const {
      value,
      validateInput
    } = this.props;
    if (value && typeof value === 'string') {
      const evt = {
        target: {
          value
        }
      };
      validateInput(evt);
    }
  }
  componentDidUpdate(previousProps) {
    // If the value prop is provided, revalidate when it changes to allow for external control of input value
    const {
      value,
      validateInput
    } = this.props;
    const {
      value: oldValue
    } = previousProps;
    if (value && typeof value === 'string' && value !== oldValue) {
      const evt = {
        target: {
          value
        }
      };
      validateInput(evt);
    }
  }
  render() {
    const _this$props = this.props,
      {
        children,
        error,
        trimInputValue = false,
        validateDefaultValue = false,
        validateInput
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(FormControl, Object.assign({}, rest, {
      error: error,
      validationMessage: this.getMessage(),
      children: /*#__PURE__*/_jsx(WrappedChildInput, {
        onChange: validateInput,
        trimInputValue: trimInputValue,
        validateDefaultValue: validateDefaultValue,
        children: children
      })
    }));
  }
}
UIValidatedFormControl.propTypes = Object.assign({}, propTypes, {
  validateInput: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  empty: PropTypes.bool.isRequired,
  isValidating: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  value: PropTypes.string
});
UIValidatedFormControl.defaultProps = {
  validationMessage: messageDefaults
};
export default UIValidator(UIValidatedFormControl);